import ArticleCard from '@/components/base/ArticleCard';
import { featuredArticles } from '@/mocks/site';

export default function HotArticles() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            精选热门文章
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            社区成员最受欢迎的内容，看看大家都在关注什么有趣的话题。
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredArticles.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              excerpt={article.excerpt}
              category={article.category}
              categorySlug={article.categorySlug}
              author={article.author}
              authorAvatar={article.authorAvatar}
              readTime={article.readTime}
              likes={article.likes}
              date={article.date}
              imageUrl={article.imageUrl}
              isHot={article.isHot}
            />
          ))}
        </div>
      </div>
    </section>
  );
}